export default __webpack_public_path__ + "static/media/bmw.c518fe35.jpg";